import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { savedAttorneyAPI, ratingAPI } from '../services/api';
import AttorneyCard from '../components/common/AttorneyCard';

const SavedAttorneys = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [ratings, setRatings] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    savedAttorneyAPI.list()
      .then(res => {
        const rows = res.data || [];
        setItems(rows);
        if (rows.length) {
          ratingAPI.bulk(rows.map(a => a.id)).then(r => setRatings(r.data || {})).catch(() => {});
        }
      })
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={styles.center}>Юкланмоқда...</div>;

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <h1 style={styles.title}>Сақланган адвокатлар</h1>

        {items.length === 0 ? (
          <div style={styles.empty}>
            <div style={styles.emptyIcon}>
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#cbd5e0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>
              </svg>
            </div>
            <p style={styles.emptyText}>Сизда ҳали сақланган адвокатлар йўқ</p>
            <button style={styles.btnPrimary} onClick={() => navigate('/find-attorney')}>
              Адвокат қидириш
            </button>
          </div>
        ) : (
          <div style={styles.list}>
            {items.map(attorney => (
              <AttorneyCard key={attorney.id} attorney={attorney} rating={ratings[attorney.id]} saved />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

const styles = {
  page: { backgroundColor: '#f7fafc', minHeight: 'calc(100vh - 120px)', padding: '3rem 2rem' },
  container: { maxWidth: '800px', margin: '0 auto' },
  title: { fontSize: '1.8rem', fontWeight: '800', color: '#1a365d', marginBottom: '2rem' },
  center: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh', fontSize: '1rem', color: '#718096' },
  empty: { textAlign: 'center', padding: '4rem 2rem', backgroundColor: 'white', borderRadius: '16px', boxShadow: '0 2px 12px rgba(0,0,0,0.06)' },
  emptyIcon: { marginBottom: '1rem' },
  emptyText: { fontSize: '1.05rem', color: '#718096', marginBottom: '1.5rem' },
  list: { display: 'flex', flexDirection: 'column', gap: '1rem' },
  btnPrimary: {
    backgroundColor: '#FFD700', color: '#0d1f17', border: 'none',
    padding: '0.85rem 2rem', borderRadius: '50px', fontSize: '0.95rem',
    fontWeight: '700', cursor: 'pointer',
  },
};

export default SavedAttorneys;
